import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

void i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'translation',
  ns: ['translation', 'market', 'outcome', 'sports'],
  resources: {
    en: {
      translation: {},
      market: {},
      outcome: {},
      sports: {},
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export { i18n };
